export const MIN_CARD_WIDTH = 300;
export const SPACE = 6;
export const ITEM_MARGIN_BOTTOM = SPACE / 2;
